export default class BCMSCurrency {
  
  // CONSTRUCTOR :: NUMBER|STRING -> this
  constructor(amount) {
      this.amount = amount;
   
  }

  // format :: {hasCents:BOOLEAN,style:STRING} -> STRING
  // NOTE: Only supported option is for hasCents and style.   
  format(options) {
      let {hasCents,hasComma,style} = options ??{};
	  const commaReplace = hasComma === false ? new RegExp(/\,/g) : "";
	
	  //style should only be set to decimal or currency.
	  switch(style){
		case "currency":
			break;
		case "decimal":
			break;
		default:
			style = "currency";		
	  }

      return new Intl.NumberFormat('en-US',{
        style: style,
        currency: 'USD',
		maximumFractionDigits: hasCents === false ? 0 :2,   // turn cents off:
        minimumFractionDigits: hasCents  !== false ? 2 : 0, // turn cents off:
      }).format(this.amount).replace(commaReplace, "");
  }
  
	/**
	 *
	 * Static:
	 *
	 */

  // STATIC FACTORY METHOD :: NUMBER|STRING -> bcmsCurrency
  static init (amount) {
      return new BCMSCurrency(amount);
  } 
  
  // toCurrency :: NUMBER -> STRING
  // Returns the amount as standard USD currency with cents
  static toCurrency(amount){
    return BCMSCurrency.init(amount).format({hasCents:true});
  }
  
  // toDecimal :: NUMBER -> STRING
  // Returns the amount as  a formated number with comma seperators
  static toDecimal(amount){
    return BCMSCurrency.init(amount).format({hasCents:true,style:"decimal"});
  }

	/**
	 *
	 * Getters:
	 *
	 */

	// :: VOID -> NUMBER|STRING
	// Returns stored amount:
	get amount() {
		return this._amount;
	}

	// :: VOID -> NUMBER
	// Returns the parsed amount
	get value() {
		return parseFloat(this._amount);
	}


/**
	 *
	 * Setters:
	 *
	 */
	// ::amount STRING|NUMBER|bcmsCurrency -> VOID
	// sets amount to be stored	
	set amount(value) {
		if(value instanceof BCMSCurrency)
		{
			this._amount = value.amount;
		}
		else if(isNaN(value) && value !== undefined){
			let regExp =/\([^)]*\)/g;
			let isNegative = regExp.test(value);			
			value = Number(value.replace(/[^0-9.-]+/g,""));
			this._amount = isNaN(value) ?
			 undefined:
			 //if string has paranthesis then it is negative
			 (value * (isNegative ? -1: 1));
		}else{
			this._amount = value;
		}   
  }
};

